export default __webpack_public_path__ + "static/media/PC-07.1a950b4f.jpg";